import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import getPresentersFromSeatingOrder from '../getPresentersFromSeatingOrder'
import { StructuredPresenterInterface } from '../structuredSelectPresenter/types'
import selectObservers from '../selectObservers'

/**
 * Returns the details of the current screen sharing presenter
 * @param state The Redux state
 */

const getScreenSharingPresenter = (state: State): string | null => state.syncUi.screenShareFocus
const getParticipants = (state: State): StructuredPresenterInterface[] => {
  const presenters = getPresentersFromSeatingOrder(state)
  const observers = selectObservers(state)
  const arrayToReturn = presenters.concat(observers)
  return arrayToReturn
}

export default createSelector(
  [getScreenSharingPresenter, getParticipants],
  (sharingPresenterId, participants) => participants.find(participant =>
    sharingPresenterId !== null && participant.BTID === sharingPresenterId))
